export const getStartParamsQuery = ({ params }) => {
    try {
        let char = '?'

        if (params) {
            char = '&'
        }

        return char
    } catch (e) {

    }
}